import { dispatchPointerEvent } from '../utils/events.es.js';
const press = {
  isActive: options => Boolean(options.press),
  subscribe: (element, _ref) => {
    let {
      enable,
      disable
    } = _ref;
    const onPointerUp = event => {
      disable();
      dispatchPointerEvent(element, "pressend", event);
      window.removeEventListener("pointerup", onPointerUp);
    };
    const onPointerDown = event => {
      enable();
      dispatchPointerEvent(element, "pressstart", event);
      window.addEventListener("pointerup", onPointerUp);
    };
    element.addEventListener("pointerdown", onPointerDown);
    return () => {
      element.removeEventListener("pointerdown", onPointerDown);
      window.removeEventListener("pointerup", onPointerUp);
    };
  }
};
export { press };